import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const Badge = ({ children, color = 'blue', className }) => {
    const colors = {
        blue: "bg-blue-900/20 border-blue-900 text-white",
        green: "bg-green-900/20 border-green-900 text-white",
        purple: "bg-purple-900/20 border-purple-900 text-white",
        orange: "bg-orange-900/20 border-orange-900 text-white",
        stone: "bg-stone-800 border-stone-600 text-white",
        red: "bg-red-900/20 border-red-900 text-white",
    };

    const isHex = color?.startsWith('#');

    if (isHex) {
        // Simple hex to rgba conversion for 20% opacity
        const r = parseInt(color.slice(1, 3), 16);
        const g = parseInt(color.slice(3, 5), 16);
        const b = parseInt(color.slice(5, 7), 16);
        const rgba = `rgba(${r}, ${g}, ${b}, 0.2)`;

        return (
            <span
                className={twMerge(clsx(
                    "text-xs px-3 h-7 inline-flex items-center justify-center rounded border text-white",
                    className
                ))}
                style={{
                    borderColor: color,
                    backgroundColor: rgba
                }}
            >
                {children}
            </span>
        );
    }

    return (
        <span className={twMerge(clsx(
            "text-xs px-3 h-7 inline-flex items-center justify-center rounded border",
            colors[color] || colors.stone,
            className
        ))}>
            {children}
        </span>
    );
};
